<template>
  <b-card
    no-body
    v-draggable
    ref="google_subcard"
    id="google-subcard"
    v-if="GoogleData != null"
  >
    <!-- Header -->
    <b-card-header
      style="color: lightgrey; height: 25px; cursor: move"
      class="pl-2 pb-0 pt-0"
      header-tag="div"
      header-bg-variant="dark"
    >
      <b-row class="mx-0 px-0">
        <b-col class="mx-0 px-0" cols="11">
          <font-awesome-icon class="mx-0" :icon="['fab', 'google']" />oogle
          <span v-if="isCompetitor">
            {{ $t("Webportal.CX.Dashboard.Exploration.Competitor") }}
          </span>
        </b-col>
        <b-col class="mx-0 px-0" cols="1" style="text-align: right">
          <font-awesome-icon
            class="mx-1 clickable"
            :icon="['far', 'times']"
            @click="close()"
          />
        </b-col>
      </b-row>
    </b-card-header>

    <!-- Content -->
    <b-img fluid style="max-height: 300px" />
    <b-card-text class="pl-3 pr-3" style="max-height: 500px; overflow: auto">
      <!-- Top menu -->
      <b-row>
        <b-col class="subcard-title">
          {{ headLine || GoogleData.Name }}
          <a target="_blank" rel="noopener" :href="GoogleMapsURI">
            <font-awesome-icon
              :icon="['far', 'map-marked-alt']"
            />
          </a>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="" cols="3" v-if="!isCompetitor">
          <CompetititorDropbox
            v-if="GoogleData.Competitors && GoogleData.Competitors.length > 0"
            :competitorList="GoogleData.Competitors"
            @openCompetitor="openCompetitor"
          />
        </b-col>
      </b-row>

      <!-- Ratings -->
      <b-row>
        <!-- Overview -->
        <b-col style="text-align: center" v-if="OverallScore">
          <p style="font-size: 3rem">{{ OverallScore }}</p>
          <b-form-rating
            :value="OverallScore"
            variant="warning"
            class
            no-border
            readonly
          />
          <p style="color: grey; font-size: 0.9rem">
            {{ ReviewCount }}
            {{ $t("Webportal.CX.Dashboard.Exploration.Google.ReviewCount") }}
          </p>
        </b-col>

        <!-- Ratings distribution -->
        <RatingDistribution
          :reviewArray="Reviews"
          barBGColor="#e9ecef"
          reviewsRatingField="Rating"
        />
      </b-row>

      <hr />

      <!-- Error handling for Competitor with no data -->
      <div v-if="isCompetitor && GoogleData.Google.Ratings == null">
        {{ $t("Webportal.CX.Dashboard.Exploration.Competitor.NoData") }}
      </div>

      <div v-else>
        <!-- Time series -->
        <!-- #1084 - no history for competitors -->
        <!-- <div v-if="!isCompetitor">
          <b-overlay variant="transparent" opacity="1" :show="isCompetitor">
            <template v-slot:overlay>&nbsp;</template>

            <ScoreHistory
              v-if="!isCompetitor"
              :apiId="GoogleData.ApiID"
            />
          </b-overlay>

          <hr />
        </div> -->

        <!-- Google Reviews -->
        <div v-if="Reviews.length <= 0">
          {{ $t("Webportal.CX.Dashboard.Exploration.NoReviews") }}
        </div>

        <div v-else>
          <p>
            {{ $t("Webportal.CX.Dashboard.Exploration.Google.Reviews") }}:
          </p>
          <div class="pb-2" style="overflow: auto; height: 50%">
            <Accordion
              v-for="(review, index) in Reviews"
              :key="index"
              class="mb-2"
            >
              <b-row slot="short" class="mb-2" style="width: 100%">
                <b-col class="pr-0" cols="3">
                  <b-avatar
                    variant="primary"
                    size="3em"
                    badge-variant="transparent"
                    :src="review.ProfilePhotoUrl"
                  >
                    <template v-slot:badge v-if="getLanguageCode(review)">
                      <span :class="'flag-icon flag-icon-' + getLanguageCode(review)"/>
                    </template>
                  </b-avatar>
                </b-col>
                <b-col>
                  <b-row
                    class="m-0 p-0"
                    style="font-size: 0.9rem; font-weight: 600; line-height: 1"
                  >
                    <b-col class="m-1 p-0 ml-n1">
                      <span>{{ review.AuthorName }}</span>
                    </b-col>
                  </b-row>
                  <b-row class="m-0 p-0 ml-n4 mb-n2" style="line-height: 1">
                    <b-col cols="7">
                      <b-form-rating
                        variant="warning"
                        class="m-0 p-0"
                        no-border
                        readonly
                        size="sm"
                        :value="review.Rating"
                      />
                    </b-col>
                    <b-col class="m-0 p-0" cols="5" style="display: flex">
                      <span>({{ review.Time.toLocaleDateString() }})</span>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <template slot="long">
                <!-- Review text message -->
                <p class="mb-2" v-if="review.Text">
                  {{ review.Text }}
                </p>
              </template>
            </Accordion>
          </div>
        </div>
      </div>
    </b-card-text>
  </b-card>
</template>

<script>
import Accordion from "../Accordion";
import CompetititorDropbox from "./CompetitorDropbox";
import RatingDistribution from "./RatingDistribution";
import DashboardService from "@/services/DashboardService";

import ScoreHistory from "./ScoreHistory";

export default {
  name: "GooglePopup",
  components: {
    Accordion,
    RatingDistribution,
    CompetititorDropbox,
    ScoreHistory
  },
  props: {
    googleData: {
      type: Object,
      default: () => {}
    },
    headLine: String,
    isCompetitor: Boolean,
    competitorId: Number
  },
  data() {
    return {
      GoogleData: null
    };
  },
  watch: {},
  computed: {
    ReviewCount: function() {
      return (
        this.GoogleData?.Google?.ReviewCount ||
        this.GoogleData?.Reviews?.length ||
        0
      );
    },

    OverallScore: function() {
      return (
        this.GoogleData?.Threshold?.Value ||
        this.GoogleData?.Google?.RatingsByName?.OverallScore?.Value ||
        0
      );
    },

    Reviews: function() {
      return this.GoogleData?.Reviews || this.GoogleData?.Google?.Reviews || [];
    },

    GoogleMapsURI: function() {
      let fullAddress = this.GoogleData.FullAddress;

      if (this.isCompetitor) {
        fullAddress = `${this.GoogleData.Name}, ${fullAddress}`;
      } else {
        fullAddress = _.replace(fullAddress, "|",", ");
        fullAddress = _.replace(fullAddress, "||", "|");
      }

      return 'https://www.google.com/maps/search/?api=1&query='+ encodeURIComponent(fullAddress);
    }
  },
  created: function() {
    window.addEventListener('keyup', this.handleKeyUp);
  },
  mounted: function() {
    if (this.isCompetitor) {
      this.getCompetitor(this.competitorId).then(response => {
        // Parse string to Date fields
        this.$parent.parseDatesForReviews(response?.data?.Google?.Reviews);
        this.GoogleData = response.data;
        this.GoogleData.Google.RatingsByName = _.keyBy(
          this.GoogleData.Google.Ratings,
          "Name"
        );
      });
    } else {
      // Clone prop
      this.GoogleData = { ...this.googleData };
    }
  },
  methods: {
    openCompetitor(id) {
      this.$emit("open-competitor", id);
    },

    getCompetitor(competitorId) {
      return DashboardService.getCompetitor(competitorId, { google: true });
    },

    getLanguageCode(review) {
      if (typeof review.Language == "undefined") return false;
      switch (review.Language) {
        case "en":
          return "gb";
        case "en-US":
          return "gb";
        case "da":
          return "dk";
        case "sv":
          return "se";
        case "el":
          return "gr";
        case "et":
          return "ee";
        case "he":
          return "il";
        case "uk":
          return "ua";
        default:
          return review.Language;
      }
    },
    close() {
      window.removeEventListener('keyup', this.handleKeyUp);
      this.$emit('close');
    },
    handleKeyUp(event) {
      if (event.key == 'Escape') {
        this.close();
      }
    },
  }
};
</script>

<style scoped>
.subcard-title {
  font-size: 1.5rem;
}
#google-subcard {
  position: fixed !important;
}
</style>
